import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { CSSProperties } from 'react'
import { AccomplishmentsListItem, ItemCheck, ItemDescription, DragIcon } from '../style'

type ListItemProps = {
  handleAccomplishmentSelect: (value: boolean, id: number) => void
  isMaxSelection: boolean
  isSelected: boolean
  index: number
  item: {
    id: number
    isSelected: boolean
    description: string
    rank: number
  }
}

export const AccomplishmentsLists = (props: ListItemProps) => {
  const { item, isSelected, isMaxSelection, index, handleAccomplishmentSelect } = props

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: item.id,
    disabled: !isSelected,
  })

  const style: CSSProperties = {
    transform: CSS.Transform.toString(
      transform ? { y: transform.y, x: 0, scaleX: 1, scaleY: 1 } : null,
    ),
    transition,
    position: 'relative',
    zIndex: isDragging ? 1 : undefined,
  }

  return (
    <AccomplishmentsListItem
      isMaxSelection={!isSelected ? isMaxSelection : false}
      id={String(item.id)}
      ref={setNodeRef}
      style={style}
      {...attributes}
    >
      <ItemCheck
        id="select_check"
        isMaxSelection={!isSelected ? isMaxSelection : false}
        isSelected={isSelected}
        onClick={() => handleAccomplishmentSelect(item.isSelected, item.id)}
      >
        {item.isSelected && index + 1}
      </ItemCheck>

      <ItemDescription isMaxSelection={!isSelected ? isMaxSelection : false}>
        {item.description}
      </ItemDescription>
      {isSelected ? <DragIcon {...listeners} /> : null}
    </AccomplishmentsListItem>
  )
}
